module.exports = __webpack_public_path__ + "static/media/notfound-mobile.b1c3e4b6.jpg";